import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { gmailApi } from '../../../lib/api/gmail';
import type { GmailAccountDTO } from '../../../types/gmail';

interface ConnectGmailButtonProps {
  orgId?: string;
  onAccountConnected: (account: GmailAccountDTO) => void;
}

export function ConnectGmailButton({ orgId, onAccountConnected }: ConnectGmailButtonProps) {
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const handleConnect = async () => {
    if (!orgId) return;
    
    try {
      setLoading(true);
      
      // Get access token
      const token = await getAccessTokenSilently();
      
      // Get the OAuth URL
      const { url } = await gmailApi.getAuthUrl(orgId, token);

      // Store orgId in sessionStorage for the callback
      sessionStorage.setItem('gmail_auth_org_id', orgId);

      // Open OAuth window
      window.location.href = url;
    } catch (error) {
      console.error('Failed to initiate Gmail connection:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleConnect}
      disabled={loading || !orgId}
      startIcon={loading ? <CircularProgress size={20} /> : null}
    >
      {loading ? 'Connecting...' : 'Connect Gmail Account'}
    </Button>
  );
} 